<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Lista de empresas</h1>
      <p class="main-subtitle">
        Total de empresas: {{ totalRecords }}
      </p>
    </div>

    <div class="flex flex-row gap-3">
      @if( UserRole.BUSSINESSMEN | notHasRole ){
        <p-button severity="primary" type="button" (onClick)="onCreateBusinessGroup()">
          <span>Crear grupo empresarial</span>
        </p-button>
        <p-button severity="primary" type="button" (onClick)="onCreateBusiness()">
          <span>Crear empresa</span>
        </p-button>
      }

    </div>
  </div>

  <!-- Sección de filtros -->
  <app-business-filter
    [businessGroupOptions]="businessGroupOptions"
    [loading]="isLoading"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  />

  <!-- Tabla listado de empresas -->
  <app-businesses-list
    [data]="filteredData"
    [totalRecords]="totalRecords"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    [first]="paginationState().first!"
    [rows]="paginationState().rows!"
    (pageChange)="onPageChange($event)"
    (toggleSort)="toggleSort($event)"
    (handleChangeBusinessStatus)="handleChangeBusinessStatus($event)"
    (handleChangeBusinessGroupStatus)="handleChangeBusinessGroupStatus($event)"
  />

  <app-confirmation-dialog
    [(visible)]="showStatusChangeDialog"
    type="warning"
    title="Cambiar de estado"
    [message]="changeStatusMessage"
    [confirmButtonText]="changeStatusButton"
    cancelButtonText="Cancelar"
    (onConfirm)="confirmStatusChange()"
    (onCancel)="cancelStatusChange()">
  </app-confirmation-dialog>

  <p-toast />
</div>
